import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import StatCard from "./StatCard";
import HotelCard from "../HotelCard";
import mockHotels from "../../data/mockHotel";
import Avatar from "../Avatar";
import TripFeedbackCard from "../TripFeedbackCard";
import TripInviteModal from "../../pages/TripInviteModal";
import CoverImage from "../../pages/curator/CoverImage";
const OverviewDashboard = ({ trip, onNavigate,startDate, user, travelKeyToken }) => {
  const uniqueMembers = [
    ...new Map(
      (trip.members || []).map(m => [m.userId?._id || m.userId, m])
    ).values()
  ];
  const city = trip.cities?.[0]?.cityName || "Trip";
  // const startDate = trip.cities?.[0]?.startDate;
  const copiedUsers = trip.copiedBy || [];
  const userName = user?.name || "Traveler";

  const duration = trip.cities?.[0]?.itineraryDays?.length || 0;
  const totalExpenses = trip.expenses?.reduce((sum, e) => sum + (e.amount || 0), 0) || 0;
  const cost = trip.costEstimate || null;
  const packingProgress = trip.packing?.length
    ? Math.round((trip.packing.filter((i) => i.packed).length / trip.packing.length) * 100)
    : 0;
  const navigate = useNavigate();
  const napprHotels = mockHotels.filter(h =>
    h.type.includes("Nappr")
  );
  const [showBudgetDetails, setShowBudgetDetails] = useState(false);
  const [showInvite, setShowInvite] = useState(false);
  const [highlight360Places, setHighlight360Places] = useState([]);
  const ENABLE_HOTEL = false; // 👈 ADD THIS
const [countdown, setCountdown] = useState("");
  const [selected360Place, setSelected360Place] = useState("");
  const extract360Places = (trip) => {
    const city = trip?.cities?.[0]?.cityName || "";

    const days = trip?.cities?.[0]?.itineraryDays || [];

    const places = [];

    days.forEach((day, dayIndex) => {
      (day.sections || []).forEach(section => {
        (section.activities || []).forEach(act => {
          if (act.location) {
            places.push({
              label: `Day ${dayIndex + 1}`,
              place: `${act.location}, ${city}`
            });
          }
        });
      });
    });

    return places.slice(0, 6); // limit for UI
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (!trip) return;

    const places = extract360Places(trip);

    setHighlight360Places(places);

    if (places.length > 0) {
      setSelected360Place(places[0].place);
    }
  }, [trip]);

  useEffect(() => {
  if (!startDate) return;

  const updateCountdown = () => {
    try {
      const now = new Date();
      const target = new Date(startDate);

      // Invalid date safety
      if (isNaN(target.getTime())) {
        setCountdown("");
        return;
      }

      const diff = target - now;

      // Trip already started
      if (diff <= 0) {
        setCountdown("Adventure Started ");
        return;
      }

      const days = Math.floor(
        diff / (1000 * 60 * 60 * 24)
      );

      const hours = Math.floor(
        (diff / (1000 * 60 * 60)) % 24
      );

      const minutes = Math.floor(
        (diff / (1000 * 60)) % 60
      );

      setCountdown(
        `${days} D • ${hours} H • ${minutes} M`
      );

    } catch (err) {
      console.error("Countdown error:", err);
      setCountdown("");
    }
  };

  // Initial run
  updateCountdown();

  // Update every minute
  const interval = setInterval(updateCountdown, 60000);

  // Cleanup
  return () => clearInterval(interval);

}, [startDate]);

  const emotionData = {
    tripMood: "Relaxed coastal nightlife",
    emotionalHook: "Golden sunsets, late-night food walks & beach mornings.",
    vibeTags: ["Food", "Nightlife", "Walkable"],
    weatherFeeling: "Perfect rooftop weather this week.",
    destinationEnergy: "Slow & vibrant",
    shareSummary: `A cinematic ${duration}-day ${city} escape.`,
    localMoment: "Golden hour starts around 6:42 PM ",
    timingInsight: "The streets become lively after sunset.",
    hiddenGemFeeling: "Most tourists miss this hidden alley.",
    socialEnergy: "The city feels calm before the weekend rush.",
    crowdMood: "Beach cafés are busiest near sunset.",
    sensoryDetails: "The sound of street musicians fills this area at night."
  };

  const stats = [
    { label: "Adventure Duration", subtext: "Enough time for hidden cafés & sunsets.", value: duration, cta: duration ? "Edit itinerary" : "Create itinerary", unit: "Days", icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z", action: "itinerary" },
    { label: "Ready For Takeoff", subtext: "Almost ready for your escape.", value: packingProgress, cta: packingProgress ? "Continue packing" : "Start packing", unit: "%", icon: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4", action: "packing" },
    { label: "Trip Comfort", subtext: "Balanced for comfort & exploration.", value: `₹${totalExpenses.toLocaleString()}`, unit: "", icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z", action: "expenses", cta: "Add expense" },
    {
      label: "Travel Vault", subtext: "All your documents safe.", value:
        (trip.documents?.length || 0) +
        (trip.tickets?.length || 0) +
        (trip.stays?.length || 0), unit: "Item", icon: "M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9l-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z", action: "vault", cta: "Open vault"
    },
  ];

  const formatCurrency = (value) => {
    if (!value) return "₹0";
    if (value >= 100000) return `₹${(value / 100000).toFixed(1)}L`;
    if (value >= 1000) return `₹${Math.round(value / 1000)}k`;
    return `₹${value}`;
  };
  const handleNavigate = (action) => {
    if (action === "vault") {
      navigate(`/trip/${travelKeyToken}/vault`);
    } else {
      onNavigate(action); // fallback (existing behavior)
    }
  };

  const currentMember = trip.members?.find(m => m.userId?._id === user?._id);
  const role = currentMember?.role || "viewer";

  // const tripOwner = trip.members?.find(m => m.role === "owner");

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="space-y-10 pb-24 lg:pb-10" // Extra padding bottom for mobile tab bar
      >
        {/* ═══════════════════ PREMIUM EXPEDITIO HEADER ═══════════════════ */}
        <header className="relative w-full h-[60vh] min-h-[400px] max-h-[600px] rounded-[2rem] sm:rounded-[2.5rem] overflow-hidden mb-8 sm:mb-12 shadow-2xl flex items-end group">
          {/* Background Image Layer */}
          <div className="absolute inset-0 w-full h-full bg-gray-900">
            <CoverImage city={city} className="w-full h-full object-cover transition-transform duration-[20s] ease-linear group-hover:scale-110" />
          </div>

          {/* Gradients for readability */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/10 pointer-events-none" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-transparent pointer-events-none" />

          {/* Top-right Actions (Invite/Share) */}
          <div className="absolute top-6 right-6 flex items-center gap-3 z-20">
            {role !== "viewer" && (
              <button
                onClick={() => setShowInvite(true)}
                className="px-4 py-2 bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 text-white text-sm font-bold rounded-full shadow-sm transition-all flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                </svg>

                Invite
              </button>
            )}
            <button
              onClick={() => navigate(`/trip/${travelKeyToken}/share`)}
              className="px-4 py-2 bg-white text-gray-900 text-sm font-bold rounded-full shadow-lg hover:scale-105 transition-all flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" /></svg>
              Share
            </button>
          </div>

          {/* Hero Content */}
          <div className="relative z-10 w-full p-6 sm:p-10 md:p-14 flex flex-col gap-6">
            <div className="flex flex-wrap items-center gap-2 sm:gap-3">
              {countdown && (
  <motion.div
    initial={{ opacity: 0, y: -10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    className="
      inline-flex items-center gap-2
      px-4 py-2
      bg-white/15 backdrop-blur-xl
      border border-white/20
      text-white
      rounded-full
      shadow-lg
    "
  >
    <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />

    <span className="text-xs font-black tracking-widest uppercase">
      {countdown}
    </span>

    <span className="text-[10px] text-white/70 font-semibold uppercase tracking-wider">
      Until Takeoff 
    </span>
  </motion.div>
)}
              {emotionData.vibeTags.map((tag, i) => (
                <span key={i} className="px-3 py-1 bg-white/20 backdrop-blur-md border border-white/30 text-white text-xs font-bold uppercase tracking-widest rounded-full">
                  {tag}
                </span>
              ))}
            </div>

            <div className="max-w-3xl">
              <motion.h1
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.1, duration: 0.8, ease: "easeOut" }}
                className="text-4xl sm:text-5xl md:text-7xl font-black text-white tracking-tight leading-[1.1] mb-4 drop-shadow-md"
              >
                {userName}'s {city} Escape
              </motion.h1>
              <motion.p
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8, ease: "easeOut" }}
                className="text-lg sm:text-2xl text-white/90 font-medium leading-relaxed drop-shadow-sm max-w-2xl"
              >
                {emotionData.emotionalHook}
              </motion.p>
            </div>

            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}
              className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8 mt-4"
            >
              {/* <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center text-xl">
                  🌤
                </div>
                <div>
                  <p className="text-[10px] text-white/70 font-bold uppercase tracking-widest">Atmosphere</p>
                  <p className="text-sm text-white font-medium">{emotionData.weatherFeeling} {emotionData.socialEnergy}</p>
                </div>
              </div> */}

              {/* <div className="hidden sm:block w-px h-10 bg-white/20" /> */}

              <div className="flex items-center gap-3">
                <div className="flex -space-x-2">
                  {uniqueMembers.slice(0, 3).map((m, i) => (
                    <Avatar key={m.userId?._id || i} user={m.userId} size="w-10 h-10" rounded="rounded-full border-2 border-transparent shadow-sm" />
                  ))}
                </div>
                <div>
                  <p className="text-[10px] text-white/70 font-bold uppercase tracking-widest">Travel Crew </p>
                  <p className="text-sm text-white font-medium">{uniqueMembers.length} {uniqueMembers.length === 1 ? 'explorer' : 'explorers'} ready</p>
                </div>
              </div>
            </motion.div>
          </div>
        </header>
        {/* ════════════════════════════════════════════════════════════════ */}

        {/* STATS GRID */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat, idx) => (
            <StatCard
              key={idx}
              {...stat}
              onNavigate={handleNavigate}
              delay={idx * 0.1}
            />
          ))}
        </div>

        {/* TRACKER & PROGRESS SECTION */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {/* Packing Widget */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2 }}
            className="lg:col-span-2 bg-white rounded-[2.5rem] p-8 sm:p-10 border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-500 relative overflow-hidden group"
          >
            <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-[#5b6f00]/5 to-transparent rounded-bl-full pointer-events-none group-hover:scale-110 transition-transform duration-700"></div>

            <div className="flex items-center justify-between mb-8 relative z-10">
              <h3 className="text-2xl font-black text-gray-900 tracking-tight">Trip Readiness</h3>
              <button
                onClick={() => onNavigate('packing')}
                className="text-xs font-bold text-[#5b6f00] bg-[#5b6f00]/10 px-5 py-2.5 rounded-xl hover:bg-[#5b6f00] hover:text-white transition-colors"
              >
                Open Checklist
              </button>
            </div>

            <div className="space-y-6 relative z-10">
              <div className="flex justify-between items-end">
                <div>
                  <span className="text-[10px] font-bold uppercase tracking-widest text-gray-400">Preparation</span>
                  <p className="text-4xl font-black text-gray-900">{packingProgress}%</p>
                </div>
              </div>
              <div className="h-5 w-full bg-gray-50 rounded-full overflow-hidden shadow-inner">
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: `${packingProgress}%` }}
                  transition={{ duration: 1.5, ease: "circOut" }}
                  className="h-full bg-[#5b6f00] rounded-full relative overflow-hidden"
                >
                  <div className="absolute inset-0 bg-white/20 w-full h-full transform -skew-x-12 translate-x-full group-hover:animate-[shimmer_2s_infinite]" />
                </motion.div>
              </div>
              <p className="text-sm font-medium text-gray-500">
                {packingProgress === 100 ? "🎉 You're fully packed and ready to escape." :
                  packingProgress > 50 ? "Almost there. Just a few more essentials for the adventure." :
                    "Let's get started. Pack your bags for an unforgettable journey."}
              </p>
            </div>
          </motion.div>

          {/* Next Up Widget */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
            className="bg-[#5b6f00] rounded-[2.5rem] p-8 sm:p-10 text-white shadow-xl shadow-[#5b6f00]/20 relative overflow-hidden group hover:shadow-2xl hover:shadow-[#5b6f00]/30 transition-all duration-500 flex flex-col justify-between"
          >
            <div className="absolute top-0 right-0 -mt-10 -mr-10 w-64 h-64 bg-white/10 rounded-full blur-3xl transition-transform group-hover:scale-125 duration-1000"></div>
            <div className="absolute bottom-0 left-0 -mb-10 -ml-10 w-48 h-48 bg-black/20 rounded-full blur-2xl"></div>

            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                </div>
                <h3 className="text-xl font-bold">Anticipation</h3>
              </div>

              {trip.cities?.[0]?.itineraryDays?.[0] ? (
                <div>
                  <p className="text-white/70 font-bold text-[10px] uppercase tracking-widest mb-2">Upcoming Moment</p>
                  <h4 className="text-3xl font-black leading-tight mb-4 tracking-tight drop-shadow-sm">Your First Evening</h4>
                  <p className="text-white/90 text-sm leading-relaxed mb-6 font-medium">{emotionData.localMoment} {emotionData.destinationEnergy}. It’s almost time to explore.</p>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 mb-8 border border-white/10">
                    <p className="text-xs text-white/90 italic font-medium">"{emotionData.sensoryDetails}"</p>
                  </div>
                </div>
              ) : (
                <div className="py-4">
                  <p className="text-white/90 text-lg font-medium leading-relaxed mb-8">Your adventure in {city} is waiting to be written.</p>
                </div>
              )}
            </div>

            <button
              onClick={() => onNavigate('itinerary')}
              className="relative z-10 w-full py-4 bg-white text-[#5b6f00] rounded-2xl font-bold text-sm hover:scale-[1.02] active:scale-95 transition-all shadow-xl shadow-[#4a5a00]/20 flex items-center justify-center gap-2 group/btn"
            >
              {trip.cities?.[0]?.itineraryDays?.[0] ? "View Itinerary" : "Start Planning"}
              <svg className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg>
            </button>
          </motion.div>
        </div>

        {/* ================= STAY OPTIONS (NAPPR) ================= */}
        {ENABLE_HOTEL && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white border border-gray-100 rounded-[2rem] p-8 shadow-sm hover:shadow-md transition-shadow"
          >

            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className="text-xl font-bold text-gray-900 tracking-tight">
                  Stay Options
                </h3>
                <p className="text-xs text-gray-400 mt-1">
                  Flexible stays powered by Nappr
                </p>
              </div>

              <button
                onClick={() => window.open("https://nappr.io", "_blank")}
                className="text-xs font-bold text-[#5b6f00] bg-[#5b6f00]/10 px-4 py-2 rounded-xl hover:bg-[#5b6f00] hover:text-white transition-colors"
              >
                View All
              </button>
            </div>

            <div className="flex gap-4 overflow-x-auto pb-2">
              {napprHotels.slice(0, 6).map((hotel) => (
                <HotelCard key={hotel.id} hotel={hotel} />
              ))}
            </div>

          </motion.div>
        )}

        {/* COLLABORATORS & COST ROW */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mt-8">
          {/* Collaborators */}
          {trip.members && trip.members.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white border border-gray-100 rounded-[2.5rem] p-8 shadow-sm hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h3 className="text-2xl font-black text-gray-900 tracking-tight">Travel Crew </h3>
                  <p className="text-sm font-medium text-gray-500 mt-1">{uniqueMembers.length} {uniqueMembers.length === 1 ? 'person' : 'people'} exploring together.</p>
                </div>
                <div className="flex -space-x-3">
                  {uniqueMembers.map((m, i) => (
                    <Avatar
                      key={m.userId?._id || i}
                      user={m.userId}
                      size="w-12 h-12"
                      rounded="rounded-full border-2 border-white shadow-sm"
                    />
                  ))}
                </div>
              </div>

              <div className="space-y-3">
                {uniqueMembers.map((m, index) => {
                  const name = m.userId?.name || m.userId?.username || "Traveler";
                  return (
                    <div key={index} className="flex items-center justify-between p-4 rounded-2xl bg-gray-50/50 hover:bg-gray-50 transition-colors group">
                      <div className="flex items-center gap-4">
                        <Avatar
                          user={m.userId}
                          size="w-12 h-12"
                          rounded="rounded-2xl shadow-sm"
                        />
                        <div>
                          <p className="text-sm font-bold text-gray-900">{name}</p>
                          <p className="text-[10px] font-bold uppercase tracking-widest text-[#5b6f00] mt-0.5">{m.role}</p>
                        </div>
                      </div>
                      {m.role === "owner" && (
                        <span className="text-xl group-hover:scale-110 transition-transform cursor-default" title="Owner">👑</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </motion.div>
          )}

          {/* Estimated Costs */}
          {cost && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white border border-gray-100 rounded-[2.5rem] p-8 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              <div className="flex-1">
                {/* HEADER */}
                <div
                  className="flex items-center justify-between mb-8 cursor-pointer group"
                  onClick={() => setShowBudgetDetails(!showBudgetDetails)}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-2xl bg-[#5b6f00]/5 text-[#5b6f00] flex items-center justify-center">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </div>
                    <div>
                      <h3 className="text-2xl font-black text-gray-900 tracking-tight">Trip Investment</h3>
                      <p className="text-sm font-medium text-gray-500 mt-1">Mid-range comfort trip</p>
                    </div>
                  </div>

                  {/* TOGGLE ICON */}
                  <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-500 group-hover:bg-[#5b6f00] group-hover:text-white transition-colors">
                    {showBudgetDetails ? "▲" : "▼"}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div className="p-6 rounded-2xl bg-gradient-to-br from-[#fdfcf7] to-white border border-[#E8E5DF]">
                    <p className="text-[10px] uppercase font-bold tracking-widest text-gray-400 mb-2">Estimated Total</p>
                    <p className="text-4xl font-black text-[#5b6f00]">{formatCurrency(cost.total)}</p>
                  </div>
                  <div className="p-6 rounded-2xl bg-white border border-gray-100 flex flex-col justify-center shadow-sm">
                    <p className="text-[10px] uppercase font-bold tracking-widest text-gray-400 mb-1">Comfort Range</p>
                    <p className="text-xl font-bold text-gray-900">{formatCurrency(cost.range?.min)} — {formatCurrency(cost.range?.max)}</p>
                  </div>
                </div>

                {/* 🔥 EXPANDABLE CONTENT */}
                {showBudgetDetails && (
                  <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} className="overflow-hidden mt-4">
                    {/* BREAKDOWN */}
                    {cost.breakdown && (
                      <div className="bg-gray-50 rounded-2xl p-6 space-y-4">
                        <div className="flex justify-between items-center">
                          <span className="text-sm font-bold text-gray-500">Stays & Hotels</span>
                          <span className="font-bold text-gray-900">{formatCurrency(cost.breakdown.hotels)}</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm font-bold text-gray-500">Food & Dining</span>
                          <span className="font-bold text-gray-900">{formatCurrency(cost.breakdown.food)}</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm font-bold text-gray-500">Transportation</span>
                          <span className="font-bold text-gray-900">{formatCurrency(cost.breakdown.transport)}</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm font-bold text-gray-500">Experiences</span>
                          <span className="font-bold text-gray-900">{formatCurrency(cost.breakdown.activities)}</span>
                        </div>
                        <div className="flex justify-between items-center border-t border-gray-200 pt-4 mt-2">
                          <span className="text-sm font-black text-gray-900">Per Explorer</span>
                          <span className="text-lg font-black text-[#5b6f00]">{formatCurrency(cost.perPerson)}</span>
                        </div>
                      </div>
                    )}
                  </motion.div>
                )}
              </div>
            </motion.div>
          )}
        </div>

        {/* COPIED BY */}
        {copiedUsers.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white border border-gray-100 rounded-[2rem] p-8 shadow-sm mt-8"
          >
            <div className="flex items-center justify-between mb-8">
              <h3 className="text-xl font-bold text-gray-900 tracking-tight">Community Reach</h3>
              <div className="bg-[#5b6f00]/10 text-[#5b6f00] px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest">
                {copiedUsers.length} Clones
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {copiedUsers.map((u, index) => (
                <div key={index} className="flex items-center justify-between p-4 rounded-2xl border border-gray-100 bg-white shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center font-bold text-gray-400 border border-gray-100">
                      {u.username?.[0]?.toUpperCase()}
                    </div>
                    <div>
                      <p className="text-sm font-bold text-gray-900">{u.username || "Traveler"}</p>
                      <p className="text-xs font-medium text-gray-400 flex items-center gap-1">
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" /></svg>
                        {new Date(u.copiedAt).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        )}
        {highlight360Places.length > 0 && (
          <section className="bg-transparent py-16">
            <div className="max-w-6xl mx-auto space-y-10">
              {/* Header */}
              <div className="text-center max-w-2xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-black text-gray-900 tracking-tight">
                  Future Memories
                </h2>
                <p className="text-base text-gray-500 mt-4 font-medium leading-relaxed">
                  Take a cinematic glimpse into the iconic places you’ll be experiencing.
                </p>
              </div>

              {/* Buttons */}
              <div className="flex flex-wrap justify-center gap-3">
                {highlight360Places.map(({ label, place }) => (
                  <button
                    key={place}
                    onClick={() => setSelected360Place(place)}
                    className={`px-6 py-3 rounded-full text-sm font-bold transition-all duration-300 shadow-sm
              ${selected360Place === place
                        ? "bg-[#5b6f00] text-white scale-105 shadow-md"
                        : "bg-white border border-gray-100 text-gray-600 hover:border-[#5b6f00]/30 hover:text-[#5b6f00] hover:bg-[#5b6f00]/5"
                      }`}
                  >
                    <span className="mr-2 opacity-70">📍</span> {place.split(",")[0]}
                  </button>
                ))}
              </div>

              {/* Map */}
              <div className="relative rounded-[2.5rem] overflow-hidden shadow-2xl border border-gray-100 bg-white p-2 group">
                <div className="rounded-[2rem] overflow-hidden relative">
                  <iframe
                    title="360 map"
                    src={`https://www.google.com/maps?q=${encodeURIComponent(
                      selected360Place
                    )}&output=svembed`}
                    className="w-full h-[500px] md:h-[600px] grayscale-[10%] contrast-110 opacity-90 group-hover:opacity-100 transition-opacity duration-1000"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 pointer-events-none ring-1 ring-inset ring-black/10 rounded-[2rem]" />
                </div>

                {/* Floating Memory Preview */}
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  key={selected360Place}
                  className="absolute bottom-8 left-8 right-8 md:left-auto md:right-8 md:w-80 bg-white/95 backdrop-blur-xl p-6 rounded-3xl shadow-xl border border-white/50 z-10"
                >
                  <div className="flex items-center gap-2 mb-3">
                    <span className="w-2 h-2 rounded-full bg-[#5b6f00] animate-pulse" />
                    <p className="text-[10px] font-bold uppercase tracking-widest text-[#5b6f00]">Local Insight</p>
                  </div>
                  <p className="text-sm font-bold text-gray-900 leading-relaxed mb-1">{emotionData.timingInsight}</p>
                  <p className="text-xs text-gray-500 italic font-medium">{emotionData.hiddenGemFeeling}</p>
                </motion.div>
              </div>
            </div>
          </section>
        )}

        <TripFeedbackCard source="Overview Dashboard" />

      </motion.div>
      <TripInviteModal
        isOpen={showInvite}
        onClose={() => setShowInvite(false)}
        travelKeyToken={travelKeyToken}
      />
    </>
  );
};

export default OverviewDashboard;
